import {
  finalEditableFieldValue,
  TodistuspyyntoTodistusKieli,
} from 'todistukset-common/src/vtj/types/editable-field.type'
import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'
import { TodistusPerson } from 'todistukset-common/src/vtj/types/todistus-person.type'
import CertificateTypes from 'todistukset-common/src/vtj/CertificateTypes.enum'
import { getPersonFullName } from 'todistukset-common/src/vtj/todistus-person.util'
import { getTodistusTypeTranslationKey } from 'todistukset-common/src/vtj/localization.util'
import { createI18nInstance } from 'common-translations/src/vtj/i18next-utils'
import todistuksetCommonTranslations from 'todistukset-common/src/vtj/localization/todistukset-common.translations'

export const getVtjOteTodistusAsiakirjaName = ({
  todistusLanguage,
  todistusType,
  person,
}: {
  todistusLanguage: TodistuspyyntoTodistusKieli
  todistusType: CertificateTypes
  person: Pick<TodistusPerson, 'firstNames' | 'lastName'>
}): string => {
  const mapTodistusLanguageToTransifexLanguage = (
    todistusLanguage: LanguageCode | null
  ) => {
    switch (todistusLanguage) {
      case LanguageCode.FI:
      case LanguageCode.SV:
      case LanguageCode.EN:
        return todistusLanguage
      default:
        return LanguageCode.EN
    }
  }

  const { t } = createI18nInstance({
    defaultBundle: todistuksetCommonTranslations,
  })
  const todistusLanguageValue = finalEditableFieldValue(todistusLanguage)
  const lng = mapTodistusLanguageToTransifexLanguage(todistusLanguageValue)
  const todistusNameTranslated = t(
    getTodistusTypeTranslationKey(todistusType),
    {
      lng,
    }
  )
  const fullName = getPersonFullName(
    person,
    t,
    {
      unknownTranslationKey: 'nameless',
    },
    lng
  )
  const todistusFileName = `${fullName} - ${todistusNameTranslated}.pdf`
  return todistusFileName
}
